import { createElement } from 'react';
import { Tag } from 'antd';
import type { DocumentRecord } from '@/entities/document/model/documentSchema';
import s from './Documents.module.scss';

export function docTypeTag(docType: DocumentRecord['docType']) {
  if (docType === 'npa') return createElement(Tag, { color: 'processing' }, 'НПА');
  if (docType === 'instruction')
    return createElement(Tag, { bordered: true, className: s['root__doc-type-tag-instruction'] }, 'Инструкция');
  return createElement(Tag, null, 'Локальный');
}

export function parseRuDate(input: string): Date | null {
  const m = input.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!m) return null;
  return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
}
